<form [formGroup]="governmentSignInForm" (ngSubmit)="onClickSignIn()" autocomplete="off">
    <div>
        <div class="form-floating">
            <input class="form-control px-4" type="text" autocomplete="off"
                [placeholder]="'GOVERNMENT_VISA.USER_ID'| translate" formControlName="commercialLoginId" appBusinessId
                [maxlength]="businessIdMaxLength" [minlength]="businessIdMinLength" />
            <label class="mandatory">{{ "GOVERNMENT_VISA.USER_ID" | translate }}</label>
            <app-validation-message [control]="governmentSignInForm.get('commercialLoginId')"></app-validation-message>
        </div>
    </div>
    <button [disabled]="!governmentSignInForm.valid" type="submit" class="btn-1 w-100 fw-700 p-2 my-4 ">
        {{ "BUSINESS_SIGN_IN.LOGIN_BUTTON" | translate }}
    </button>
</form>
<!-- captcha-->
@if(showCaptcha){
<app-captcha (allowAccess)="handleRecaptchaResponse($event)"></app-captcha>
}